<div class="ui attached segment" appMargin marginT="5">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div fxFlex="25%">
      <div class="icons">
        <img src="assets/icons/envelope-sm.svg" alt="" *ngIf="alertNotification?.email?.length">
        <img src="assets/icons/slack-sm.svg" alt="" *ngIf="alertNotification?.slack?.length">
    </div>
    </div>
    <div fxFlex="30%">
      {{ alertNotification?.description }}
    </div>
    <div fxFlex="15%">
      {{ parseItem(alertNotification?.configuration).minimumCount }}
    </div>
    <div fxFlex="14%">
      {{ parseItem(alertNotification?.configuration).timeframe }}
    </div>
    <div fxFlex="15%">
      {{ alertNotification?.dateTriggered | date: "d, MMMM y, h:mma" }}
    </div>
  </div>
</div>
